import {
  FETCH_RETAILER,
  RESET_RETAILER,
} from "../../constants/action.constants";

const initialState = {
  data: {},
};

const retailerViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_RETAILER:
      return { data: action.payload };
    case RESET_RETAILER:
      return initialState;
    default:
      return state;
  }
};

export default retailerViewReducer;
